<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 "
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col items-center px-18px md:px-6 lg:px-0 pt-10 pb-12 lg:py-20 col-span-full md:col-start-1 lg:col-start-2 md:col-end-9 lg:col-end-12"
    >
      <p
        class="uppercase text-3xl font-bold"
        v-text="container.title"
        :class="container.titleStyles"
      />
      <p
        class="text-lg font-medium pt-6 lg:pt-58px"
        v-text="container.subTitle"
        :class="container.subTitleStyles"
      />
      <p
        class="text-lg pt-md lg:pt-26px"
        v-text="container.text"
        :class="container.textStyle"
      />
      <section class="pt-8 lg:pt-20 flex flex-col gap-y-12 lg:gap-y-18.5">
        <text-image-box :htmlText="container.firstItem" :hasCircle="true" :icon="container.Icon" :haveIcon="true" :haveImg="true" :boxImg="container.boxImg"  :textStyles="container.textItemStyles" />
        <text-image-box
          :hasCircle="true"
          :haveIcon="true"
          :haveImg="true"
          :boxImg="container.secondBoxImg"
          :icon="container.Icon"
          class="border-gray-400 md:px-8 lg:px-0 lg:border-none"
          :htmlText="container.secondItem"
          :isInverted="true"
          :textStyles="container.textItemStyles"
        />
      </section>
    </section>
  </section>
</template>
<script>
export default {
  components: {
    TextImageBox: () => import("../components/TextImageBox.vue"),
  },
  data: () => ({
    contactData: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
    },
  }),
  props:{
    withBorder:{
      default: true
    },
    container:{
      default: null,
    }
  }
};
</script>
